<template>
  <div class="furniture-transport">
    <input-label :text="$t('elevator.lift.label')"/>
    <input-selector v-model="liftSync"
                    data-cy="lift-options"
                    :options="liftOptions"
                    button-class="elevator-button"/>
    <next-transition :visible="liftSync !== null && liftSync !== false">
      <input-label :text="$t('elevator.lift_comment.label')"/>
      <input-selector v-model="lift_commentSync"
                      data-cy="lift-comment"
                      :options="lift_commentOptions"/>
    </next-transition>
    <next-transition :visible="displayAllInLiftQuestion">
      <input-label :text="$t('furnitureTransport.all_in_lift.label')"/>
      <input-selector v-model="all_in_liftSync"
                      data-cy="all-in-lift"
                      :options="yesNoDuno"
                      button-class="furniture-button"/>
    </next-transition>
    <next-transition :visible="displayStairs">
      <input-label :text="$t('furnitureTransport.stairs.label')"/>
      <input-selector v-model="stairsSync"
                      data-cy="stairs"
                      :options="stairsOptions"
                      button-class="furniture-button"
      />
    </next-transition>
    <next-transition :visible="displayMMUtilisable">
      <input-label :text="$t('furnitureTransport.mm_utilisable.label')"/>
      <input-selector
        v-model="mm_utilisableSync"
        data-cy="mm_utilisable"
        :options="yesNoDuno"
        button-class="furniture-button"
      />
    </next-transition>
    <next-transition :visible="displayMMObligatoire">
      <input-label :text="$t('furnitureTransport.mm_obligatoire.label')"/>
      <input-selector v-model="mm_obligatoireSync"
                      data-cy="mm_obligatoire"
                      button-class="furniture-button"
                      :options="yesNoDuno"/>
    </next-transition>
  </div>
</template>

<script>
import InputSelector from '@/components/utils/InputSelector.vue';
import InputLabel from '@/components/utils/InputLabel.vue';

import NextTransition from '@/components/utils/NextTransition.vue';

export default {
  name: 'furnitureTransport',
  components: {
    NextTransition,
    InputLabel,
    InputSelector,
  },
  computed: {
    all_in_liftSync: {
      get() {
        return this.$store.getters[`${this.parentRoute}Store/floor`]?.all_in_lift;
      },
      set(all_in_lift) {
        this.$store.commit(`${this.parentRoute}Store/SET_ALL_IN_LIFT`, all_in_lift);
      },
    },
    stairsSync: {
      get() {
        return this.$store.getters[`${this.parentRoute}Store/floor`]?.stairs;
      },
      set(stairs) {
        this.$store.commit(`${this.parentRoute}Store/SET_STAIRS`, stairs);
      },
    },
    mm_utilisableSync: {
      get() {
        return this.$store.getters[`${this.parentRoute}Store/floor`]?.mm_utilisable;
      },
      set(mm_utilisable) {
        this.$store.commit(`${this.parentRoute}Store/SET_MM_UTILISABLE`, mm_utilisable);
      },
    },
    mm_obligatoireSync: {
      get() {
        return this.$store.getters[`${this.parentRoute}Store/floor`]?.mm_obligatoire;
      },
      set(mm_obligatoire) {
        this.$store.commit(`${this.parentRoute}Store/SET_MM_OBLIGATOIRE`, mm_obligatoire);
      },
    },
    stairsOptions() {
      return [
        {
          label: this.$t('base.yes'),
          value: 0,
        },
        {
          label: this.$t('base.no'),
          value: 1,
        },
        {
          label: this.$t('base.duno'),
          value: -1,
        },
      ];
    },
    yesNo() {
      return [
        {
          label: this.$t('base.yes'),
          value: 1,
        },
        {
          label: this.$t('base.no'),
          value: 0,
        },
      ];
    },
    yesNoDuno() {
      return [
        ...this.yesNo,
        {
          label: this.$t('base.duno'),
          value: -1,
        },
      ];
    },
    liftSync: {
      get() {
        return this.$store.getters[`${this.parentRoute}Store/floor`]?.lift;
      },
      set(lift) {
        this.$store.commit(`${this.parentRoute}Store/SET_LIFT`, lift);
      },
    },
    liftOptions() {
      return [
        {
          label: this.$t('base.yes'),
          value: true,
        },
        {
          label: this.$t('base.no'),
          value: false,
        },
      ];
    },
    lift_commentSync: {
      get() {
        return this.$store.getters[`${this.parentRoute}Store/floor`]?.lift_comment;
      },
      set(lift_comment) {
        this.$store.commit(`${this.parentRoute}Store/SET_LIFT_COMMENT`, lift_comment);
      },
    },
    lift_commentOptions() {
      return [
        {
          label: this.$t('elevator.lift_comment.options.small'),
          value: '1-2 pers',
        },
        {
          label: this.$t('elevator.lift_comment.options.middle'),
          value: '3-4 pers',
        },
        {
          label: this.$t('elevator.lift_comment.options.big'),
          value: '5-6 pers',
        },
        {
          label: this.$t('elevator.lift_comment.options.veryBig'),
          value: '7-8 pers',
        },
      ];
    },
    parentRoute() {
      return this.$store.getters['routeStore/parentRoute'];
    },
    displayAllInLiftQuestion() {
      return (this.liftSync === true && this.lift_commentSync !== '');
    },
    displayStairs() {
      return (this.liftSync === true && this.all_in_liftSync !== 1 && this.all_in_liftSync !== null)
        || this.liftSync === false;
    },
    displayMMUtilisable() {
      return (this.stairsSync !== null && this.all_in_liftSync !== 1);
    },
    displayMMObligatoire() {
      return ((this.mm_utilisableSync === 1 || this.mm_utilisableSync === -1)
        && this.stairsSync === 0);
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep {
  .furniture-button {
    flex: initial !important;
    word-break: keep-all !important;
  }
}

::v-deep {
  .elevator-button {
    flex: initial !important;
    width: 100px !important;
    word-break: keep-all !important;
  }
}
</style>
